import {
    FormControlLabel, Checkbox, FormControl, MenuItem, InputLabel, Select,
    Paper, Table, Grid, TextField, InputAdornment, ListItemText, Dialog, DialogTitle, DialogContent,
} from '@mui/material';
import { Chip } from '@mui/material';
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { AllCommunityModule, ModuleRegistry, DateFilterModule, } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../lib/axios';
import { Box, Typography, CircularProgress, Tooltip, IconButton, Button } from '@mui/material';
import { usePermissions } from '../../GlobalFunction/userPermissions';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../../redux/propertySlice';
import { useNavigate, useLocation } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import '../../AgGridStyle.css';
import HomeIcon from '@mui/icons-material/Home';
import DownloadIcon from '@mui/icons-material/Download';
import CalendarReport from './CalendarReport';
import CloseIcon from '@mui/icons-material/Close';

import { getYojnaMasterdropdata, getShiftMasterdropdata, getRoomMasterdropdata } from '../../Api/PropertyMst/Api';
import PDFReport, { generateAndDownloadPDF } from './PDFReport'; 
import { generateAndDownloadCalendarPDF } from './PDFReport';


ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule,]);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const Weektaskreport = () => {
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const UserId = sessionStorage?.getItem('UserId');
    const permissions = usePermissions("Promocode Master");
    const [yojna, setYojna] = useState([]);
    const [shiftData, setShiftData] = useState([]);
    const [propertyData, setPropertyData] = useState([]);
    const [AddRec, setAddRec] = useState("0");
    const [selectedYojnas, setSelectedYojnas] = useState([]);
    const [activeDays, setActiveDays] = useState([]);
    const gridRef = useRef();
    const navigate = useNavigate();
    const globalProperty = useSelector(selectGlobalProperty);
    const location = useLocation();
    const [openDialog, setOpenDialog] = useState(false);
   const [calendarData, setCalendarData] = useState([]);
    
 const generateCalendarPDFReport = () => {
    if (rowData.length === 0) {
        toast.warning('No data to print');
        return;
    }

    try {

        const workstations = [...new Set(rowData.map(item => item.HkWrkStnName))].filter(Boolean);
   
        const tasks = [...new Set(rowData.map(item => item.HkTaskName))].filter(Boolean);
     
        const fromDate = formData.FromDate;
        const toDate = formData.ToDate;

        const propertyName = propertyData.find(p => p.id.toString() === formData.Property)?.name || 'Property';
        
   
        const shiftName = shiftData.find(s => s.id.toString() === formData.Shift)?.name || 'Shift';
        

        generateAndDownloadCalendarPDF({
            rowData,
            workstations,
            tasks,
            fromDate,
            toDate,
            propertyName,
            shiftName,
            selectedYojnas,
            yojnaData: yojna,
            days: DAYS,
            fileName: `Task_Calendar_${fromDate}_to_${toDate}.pdf`
        });
        
        toast.success('Calendar PDF downloaded successfully');
    } catch (error) {
        console.error('PDF generation error:', error);
        toast.error('Error generating calendar PDF');
    }
};



    const handleOpen = () => {
        setOpenDialog(true);
    };

    const closeDialog = () => {
        setOpenDialog(false);
    };

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getMaxDate = () => {
        const maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 30);
        const year = maxDate.getFullYear();
        const month = String(maxDate.getMonth() + 1).padStart(2, '0');
        const day = String(maxDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (location.state && location.state.rowData) {
            setFormData({
                Property: location.state.propertyId || '',
                Shift: location.state.shiftId || '',
                Yojna: '',
                FromDate: location.state.fromDate || todayDate,
                ToDate: location.state.toDate || todayDate,
            });

            if (location.state.selectedYojnas) {
                setSelectedYojnas(location.state.selectedYojnas);
            }

            if (location.state.rowData) {
                fetchReportData(location.state.rowData);
            }
        }
    }, [location.state]);

    const todayDate = getTodayDate();
    const maxDate = getMaxDate();

    const [formData, setFormData] = useState({
        Property: '',
        Shift: '',
        Yojna: '',
        FromDate: todayDate,
        ToDate: todayDate,
    });

    const determineActiveDays = (data) => {
        if (!data || data.length === 0) return [];

        const activeDaySet = new Set();

        data.forEach(row => {
            DAYS.forEach(day => {
                if (row[day] === "1") {
                    activeDaySet.add(day);
                    activeDaySet.add(`${day}A`);
                }
                else if (row[`${day}A`] === "1") {
                    activeDaySet.add(`${day}A`);
                }
            });
        });

        const sortedDays = Array.from(activeDaySet).sort((a, b) => {
            const order = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
                'SunA', 'MonA', 'TueA', 'WedA', 'ThuA', 'FriA', 'SatA'];
            return order.indexOf(a) - order.indexOf(b);
        });

        return sortedDays;
    };

    const colDefs = useMemo(() => {
        const baseColumns = [
            { field: 'RowNum', headerName: 'Sr.No', width: 60 },
            { field: 'YojanaName', headerName: 'Yojana', width: 220 },
            { field: 'HkWrkStnName', headerName: 'Work Station', width: 150 },
            { field: 'HkWrkAreaName', headerName: 'Work Area', width: 200 },
            { field: 'HkTaskName', headerName: 'Task', width: 220 },
            {
                field: 'WrkRecvDt',
                headerName: 'Received Date',
                width: 130,
                valueFormatter: (params) => {
                    if (!params.value) return '';
                    const date = new Date(params.value);
                    return date.toLocaleDateString('en-IN');
                }
            },
        ];

        const planColumnSimple = {
            field: 'Plan',
            headerName: 'Plan',
            width: 100,
            valueGetter: (params) => {
                const hasPlan = DAYS.some(day => params.data[day] === "1");
                return hasPlan ? 1 : 0;
            },
            cellRenderer: (params) => {
                const activePlanDays = DAYS.filter(day => params.data[day] === "1");

                return (
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '2px',
                        alignItems: 'center',
                        height: '100%'
                    }}>
                        {activePlanDays.map((day, index) => (
                            <Checkbox
                                key={`plan-${day}-${index}`}
                                checked={true}
                                disabled
                                size="small"
                                sx={{
                                    padding: '2px',
                                    '&.Mui-checked': {
                                        color: '#4caf50'
                                    }
                                }}
                            />
                        ))}
                        {activePlanDays.length === 0 && (
                            <Typography variant="caption" color="textSecondary" sx={{ fontStyle: 'italic', fontSize: '11px' }}>
                                -
                            </Typography>
                        )}
                    </Box>
                );
            },
            filter: 'agNumberColumnFilter',
            filterValueGetter: (params) => {
                const hasPlan = DAYS.some(day => params.data[day] === "1");
                return hasPlan ? 1 : 0;
            }
        };

        const actualColumnSimple = {
            field: 'Actual',
            headerName: 'Actual',
            width: 100,
            valueGetter: (params) => {
                const hasActual = DAYS.some(day => params.data[`${day}A`] === "1");
                return hasActual ? 1 : 0;
            },
            cellRenderer: (params) => {
                const activeActualDays = DAYS.filter(day => params.data[`${day}A`] === "1");

                return (
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '2px',
                        alignItems: 'center',
                        height: '100%'
                    }}>
                        {activeActualDays.map((day, index) => (
                            <Checkbox
                                key={`actual-${day}-${index}`}
                                checked={true}
                                disabled
                                size="small"
                                sx={{
                                    padding: '2px',
                                    '&.Mui-checked': {
                                        color: '#ff9800'
                                    }
                                }}
                            />
                        ))}
                        {activeActualDays.length === 0 && (
                            <Typography variant="caption" color="textSecondary" sx={{ fontStyle: 'italic', fontSize: '11px' }}>
                                -
                            </Typography>
                        )}
                    </Box>
                );
            },
            filter: 'agNumberColumnFilter',
            filterValueGetter: (params) => {
                const hasActual = DAYS.some(day => params.data[`${day}A`] === "1");
                return hasActual ? 1 : 0;
            }
        };

        const additionalColumns = [
            {
                field: 'Remark',
                headerName: 'Todo List',
                width: 250,
                cellRenderer: (params) => (
                    <Tooltip title={params.value || '-'} arrow placement="top">
                        <div style={{ width: '100%' }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    cursor: 'default',
                                }}
                            >
                                {params.value || '-'}
                            </Typography>
                        </div>
                    </Tooltip>
                )
            },
            {
                field: 'Msg',
                headerName: 'Comments',
                width: 150,
            },
            {
                field: 'QCPoints',
                headerName: 'Points',
                width: 100,
            },
        ];

        return [...baseColumns, planColumnSimple, actualColumnSimple, ...additionalColumns];

    }, [DAYS]);


    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        floatingFilter: true,
        width: 100,
        tooltipValueGetter: (params) => params.value ?? '',
    }), []);

    useEffect(() => {
        fetchYojnaData();
        fetchShiftData();
        fetchPropertyData();
    }, []);

    const fetchYojnaData = async () => {
        try {
            const response = await getYojnaMasterdropdata({
                Flag: "",
                YojanaId: 1
            });
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data.map((item) => ({
                    id: item.YojanaId,
                    name: item.YojanaName,
                }));
                setYojna(dropdownItems);
            }
        } catch (error) {
            toast.error("Error fetching yojna data");
        }
    };

    const fetchShiftData = async () => {
        try {
            const response = await getShiftMasterdropdata();
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data.map((item) => ({
                    id: item.ShiftId,
                    name: item.ShiftName,
                }));
                setShiftData(dropdownItems);
                if (dropdownItems.length > 0) {
                    setFormData(prev => ({
                        ...prev,
                        Shift: dropdownItems[0].id.toString()
                    }));
                }
            }
        } catch (error) {
            toast.error("Error fetching shift data");
        }
    };

    const fetchPropertyData = async () => {
        try {
            const response = await getRoomMasterdropdata({
                Flag: "",
                UserId: UserId,
            });
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data?.map((item) => ({
                    id: item.PropId,
                    name: item.Name,
                }));
                setPropertyData(dropdownItems);

                if (globalProperty) {
                    setFormData(prev => ({ ...prev, Property: globalProperty.toString() }));
                } else if (dropdownItems.length > 0) {
                    setFormData(prev => ({ ...prev, Property: dropdownItems[0].id.toString() }));
                }
            }
        } catch (error) {
            toast.error("Error fetching property data");
        }
    };

    const fetchReportData = async (rowDataFromDoubleClick = null) => {
        setIsLoading(true);
        try {
            const isFromDoubleClick = rowDataFromDoubleClick !== null;
            let propId, shiftId, fromDate, toDate;

            if (isFromDoubleClick) {
                propId = parseInt(rowDataFromDoubleClick.PropId) || parseInt(location.state?.propertyId);
                shiftId = parseInt(rowDataFromDoubleClick.ShiftId) || parseInt(location.state?.shiftId);
                fromDate = rowDataFromDoubleClick.WrkRecvDt || formData.FromDate;
                toDate = rowDataFromDoubleClick.WrkRecvDt || formData.ToDate;
            } else {
                propId = parseInt(formData.Property);
                shiftId = parseInt(formData.Shift);
                fromDate = formData.FromDate;
                toDate = formData.ToDate;
            }

            const payload = {
                PropId: propId || parseInt(formData.Property),
                YojanaId: 1,
                ShiftId: shiftId || parseInt(formData.Shift),
                HkWrkAreaId: 1,
                StrHkTaskId: "",
                StrYojanaId: selectedYojnas.length > 0 ? selectedYojnas.join(',') : "",
                StrHkWrkAreaId: "",
                WrkRecvDt: fromDate,
                WrkRecvToDt: toDate,
                Flag: isFromDoubleClick ? "TaskRptDtDetails" : ""
            };

            const response = await axiosInstance.post(
                'MstYojana/RetriveGetTrnWrkRecvTaskDtWise',
                payload
            );

            if (response.data.Status === 0 && response.data.Data?.length > 0) {
                const formattedData = response.data.Data.map((item, index) => ({
                    ...item,
                    RowNum: index + 1,
                    QCComments: item.QCComments || '',
                    QCPoints: item.QCPoints || 0,
                    Performance: item.Performance || '',
                    ToDoList: item.ToDoList || ''
                }));

                // Determine which days have "1" values
                const activeDayColumns = determineActiveDays(formattedData);
                setActiveDays(activeDayColumns);

                setRowData(formattedData);
            } else {
                setRowData([]);
                setActiveDays([]);
                toast.info(response.data.Message || 'No data found for selected criteria');
            }
        } catch (error) {
            toast.error('Error fetching report data');
            setRowData([]);
            setActiveDays([]);
        } finally {
            setIsLoading(false);
        }
    };

  
    const exportToExcel = () => {
        if (!gridRef.current || !gridRef.current.api) {
            toast.error('Grid not ready for export');
            return;
        }

        if (rowData.length === 0) {
            toast.warning('No data to export');
            return;
        }

        setIsExporting(true);

        try {
     
            const columns = colDefs.map(col => col.headerName || col.field);

            const displayedRows = [];
            gridRef.current.api.forEachNodeAfterFilterAndSort(node => {
                displayedRows.push(node.data);
            });

            const exportData = displayedRows.map(row => {
                const rowData = {};

                colDefs.forEach(col => {
                    const field = col.field;
                    let value = row[field];

                    if (field === 'WrkRecvDt' && value) {
                        const date = new Date(value);
                        value = date.toLocaleDateString('en-IN');
                    }

                    if (field === 'Plan') {
      
                        const activePlanDays = DAYS.filter(day => row[day] === "1");
                        value = activePlanDays.length > 0 ? activePlanDays.join(', ') : '';
                    } else if (field === 'Actual') {

                        const activeActualDays = DAYS.filter(day => row[`${day}A`] === "1");
                        value = activeActualDays.length > 0 ? activeActualDays.map(d => d + 'A').join(', ') : '';
                    }

                    rowData[col.headerName || field] = value !== undefined && value !== null ? value : '';
                });

                return rowData;
            });

          
            const headers = colDefs.map(col => col.headerName || col.field);
            const csvContent = [
                headers.join(','),
                ...exportData.map(row =>
                    headers.map(header => {
                        const value = row[header];
                     
                        if (typeof value === 'string' && value.includes(',')) {
                            return `"${value}"`;
                        }
                        return value;
                    }).join(',')
                )
            ].join('\n');

            // Create and download CSV file
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `Daily_Task_Report_${formData.FromDate}_to_${formData.ToDate}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            toast.success(`Exported ${exportData.length} records successfully`);
        } catch (error) {
            toast.error('Error exporting data');
        } finally {
            setIsExporting(false);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleYojnaMultiSelect = (event) => {
        const { value } = event.target;
        setSelectedYojnas(typeof value === 'string' ? value.split(',') : value);
    };

    const handleClearFilters = () => {
        gridRef.current?.api?.setFilterModel(null);
    };

    const onGridReady = useCallback((params) => {
        // Grid ready handler
    }, []);

    return (
        <Box
            sx={{
                width: '100%',
                height: '90vh',
                padding: '10px',
                backgroundColor: 'rgb(249, 249, 249)',
                position: 'relative'
            }}
        >
            <ToastContainer />
            <Box
                sx={{
                    backgroundColor: "#ffffff",
                    padding: { xs: "8px 16px", sm: "12px 16px" },
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                    borderRadius: "12px",
                    margin: "10px auto",
                    maxWidth: "95%",
                }}
            >
                <Breadcrumbs
                    aria-label="breadcrumb"
                    separator="›"
                    sx={{
                        fontSize: { xs: "14px", sm: "16px" },
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                    }}
                >
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                        onClick={() => navigate('/dashboard')}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        <Box component="span">Home</Box>
                    </Link>
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                        onClick={() => navigate('/reports/dailysummaryreport')}
                    >
                        Report
                    </Link>
                    <Typography color="text.primary" sx={{ fontWeight: "500" }}>
                        Task Report
                    </Typography>
                </Breadcrumbs>

                <Box
                    sx={{
                        display: "flex",
                        flexWrap: { xs: "wrap", sm: "wrap", md: "nowrap" },
                        gap: 1,
                        alignItems: "center",
                        justifyContent: { xs: "flex-start", sm: "flex-start", md: "flex-end" },
                        width: "100%",
                    }}
                >
                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "150px", md: "130px" } }}
                        className="custom-textfield"
                    >
                        <InputLabel>Property</InputLabel>
                        <Select name="Property" value={formData.Property} onChange={handleInputChange}>
                            {propertyData.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "120px", md: "120px" } }}
                        className="custom-textfield"
                    >
                        <InputLabel>Shift</InputLabel>
                        <Select name="Shift" value={formData.Shift} onChange={handleInputChange}>
                            {shiftData.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{ width: { xs: "100%", sm: "250px", md: "150px" } }}
                        className="custom-textfield"
                    >
                        <InputLabel id="yojna-multi-label">Yojna Name</InputLabel>
                        <Select
                            labelId="yojna-multi-label"
                            multiple
                            value={selectedYojnas}
                            onChange={handleYojnaMultiSelect}
                            renderValue={(selected) => {
                                if (selected.length === 0) return <em>Select Yojna(s)</em>;

                                const selectedNames = selected.map(id => {
                                    const item = yojna.find(item => item.id.toString() === id.toString());
                                    return item?.name || id;
                                });

                                if (selectedNames.length > 2) {
                                    return (
                                        <Tooltip title={selectedNames.join(', ')} arrow>
                                            <span>{`${selectedNames.slice(0, 2).join(', ')} +${selectedNames.length - 2} more`}</span>
                                        </Tooltip>
                                    );
                                }
                                return selectedNames.join(', ');
                            }}
                            MenuProps={MenuProps}
                        >
                            {yojna.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    <Checkbox checked={selectedYojnas.indexOf(item.id.toString()) > -1} sx={{ padding: "2px" }} />
                                    <ListItemText primary={item.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <TextField
                        label="From Date"
                        type="date"
                        name="FromDate"
                        value={formData.FromDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ max: maxDate, min: '2020-01-01' }}
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "150px", md: "140px" } }}
                        className="custom-textfield"
                    />

                    <TextField
                        label="To Date"
                        type="date"
                        name="ToDate"
                        value={formData.ToDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ max: maxDate, min: formData.FromDate }}
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "150px", md: "140px" } }}
                        className="custom-textfield"
                    />

                    <Button
                        variant="contained"
                        onClick={fetchReportData}
                        disabled={isLoading}
                         size='small'
                        sx={{ bgcolor: '#635bff', '&:hover': { bgcolor: '#5248cc' },  textTransform: 'none' }}
                    >
                        {isLoading ? 'Loading..' : 'Search'}
                    </Button>

                    <Tooltip title='Export to Excel' arrow>
                        <Button
                            variant="contained"
                            onClick={exportToExcel}
                            disabled={isExporting || rowData.length === 0}
                            startIcon={<DownloadIcon />}
                            size='small'
                            sx={{ bgcolor: '#2e7d32', '&:hover': { bgcolor: '#1b5e20' },  textTransform: 'none' }}
                        >
                            {isExporting ? 'Exporting...' : 'Export'}
                        </Button>
                    </Tooltip>

                    <Tooltip title='Check Calendar' arrow>
                        <Button variant="contained" size='small' onClick={handleOpen} sx={{ bgcolor: '#635bff', ":hover": { bgcolor: '#635bff' }, textTransform: 'none' }}>Calendar</Button>
                    </Tooltip>
                    {/* <Tooltip title='Print Pdf' arrow>
                        <Button disabled={isExporting || rowData.length === 0} variant="contained" size='small'  onClick={generateCalendarPDFReport} sx={{ bgcolor: '#7bc440', ":hover": { bgcolor: '#45a111' }, textTransform: 'none' }}>Print</Button>
                    </Tooltip> */}

                    <Tooltip title='Previous Page' arrow>
                        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                            <IconButton
                                onClick={() => navigate('/reports/dailysummaryreport')}
                                size='small'
                                sx={{
                                    backgroundColor: '#635bff',
                                    borderRadius: '50%',
                                    width: 35,
                                    height: 35,
                                   
                                    '&:hover': { backgroundColor: '#635bff' },
                                    boxShadow: 3,
                                }}
                            >
                                <ArrowBackIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            </Box>

            <Box
                className="ag-theme-alpine"
                sx={{
                    height: 'calc(95% - 100px)',
                    width: '95%',
                    margin: '0 auto',
                    position: 'relative'
                }}
            >
                {isLoading ? (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center',
                        }}
                    >
                        <CircularProgress size="3rem" sx={{ color: '#635bff' }} />
                        <Typography sx={{ marginTop: 2, color: '#635bff', fontWeight: 'bold' }}>
                            Loading data...
                        </Typography>
                    </Box>
                ) : (
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={colDefs}
                        defaultColDef={defaultColDef}
                        pagination={true}
                        paginationPageSize={1000}
                        paginationPageSizeSelector={[1000, 5000, 10000]}
                        onGridReady={onGridReady}
                        enableCellTextSelection={true}
                        rowHeight={28} // Reduced row height to 28px
                        headerHeight={35}
                        floatingFiltersHeight={30}
                        overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">No data to display</span>'}
                        tooltipShowDelay={0}
                        getRowStyle={(params) => ({
                            backgroundColor: params.node.rowIndex % 2 === 0 ? '#f8f9fa' : '#ffffff'
                        })}
                    />
                )}
                {rowData.length > 0 && (
                    <Box sx={{
                        position: 'absolute',
                        bottom: 16,
                        left: 70,
                        fontSize: '14px',
                        color: 'black',
                    }}>
                        Total Records: <b>{rowData.length}</b>
                    </Box>
                )}
            </Box>

            <Dialog open={openDialog} onClose={closeDialog} maxWidth="lg" fullWidth>
                <DialogTitle
                    id="calendar-report-dialog"
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}
                >
                    Calendar Report
                    <CloseIcon
                        onClick={closeDialog}
                        sx={{ cursor: 'pointer', color: 'red', '&:hover': { color: 'red' } }}
                        aria-label="close"
                    />
                </DialogTitle>

                <DialogContent dividers>
                    <CalendarReport
                        shift={shiftData}
                        yojna={yojna}
                        property={propertyData}
                        selectedProperty={formData.Property}
                        selectedShift={formData.Shift}
                        selectedYojnas={selectedYojnas}
                        fromDate={formData.FromDate}
                        toDate={formData.ToDate}
                    />
                </DialogContent>
            </Dialog>
   
        </Box>
    );
};

export default Weektaskreport;